import { Link } from "react-router-dom";
import logo from "../../assets/images/gdcl.png";
import { jwtDecode } from "jwt-decode";
import avatar from "../../assets/images/avatar.png";
import Button from '@mui/material/Button';
import { MdOutlineMenu } from "react-icons/md";
import { MdMenuOpen } from "react-icons/md";
import { MdDarkMode } from "react-icons/md";
import { MdOutlineLightMode } from "react-icons/md";
import { IoIosNotifications } from "react-icons/io";
import SearchBox from "../SearchBox";
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import { useState } from "react";

const token = localStorage.getItem("token");
let decoded = "";
if (token) {
    decoded = jwtDecode(token);
}


const Headers = () => {
    const [anchorElNotification, setAnchorElNotification] = useState(null);
    const openNotification = Boolean(anchorElNotification);
    // const empCode = localStorage.getItem(empCode)

    // Notification menu handlers
    const handleNotificationClick = (event) => {
        setAnchorElNotification(event.currentTarget);
    };
    const handleNotificationClose = () => {
        setAnchorElNotification(null);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');

        window.location.href = '/';
    }


    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleMyAccClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMyAccClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <header className="d-flex align-items-center">
                <div className="container-fluid w-100">
                    <div className="row d-flex align-items-center w-100">
                        <div className="col-sm-2 part1">
                            <Link to={"./"} className="d-flex align-items-center logo  text-decoration-none">
                                <img src={logo} />
                                <span className="ml-2">GDCL</span>
                            </Link>
                        </div>
                        <div className="col-sm-3 d-flex align-items-center part2 pl-4">
                            <SearchBox />
                        </div>

                        <div className="col-sm-7 d-flex align-items-center justify-content-end part3">
                            {/* <Button className="rounded-circle mr-3" onClick={handleNotificationClick}><IoIosNotifications /></Button> */}

                            {/* <Menu
                                anchorEl={anchorElNotification}
                                id="notification-menu"
                                open={openNotification}
                                onClose={handleNotificationClose}
                                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                            >
                                <MenuItem onClick={handleNotificationClose}>🔔 New Notification</MenuItem>
                                <MenuItem onClick={handleNotificationClose}>📅 Meeting at 3 PM</MenuItem>
                                <MenuItem onClick={handleNotificationClose}>✅ Leave Approved</MenuItem>
                            </Menu> */}

                            <div className="myAccWrapper">
                                <Button onClick={handleMyAccClick} className="myAcc d-flex align-items-center">
                                    {/* <div className="userImg">
                                        <span className="rounded-circle">
                                            <img src={avatar} />
                                        </span>
                                    </div> */}
                                    <div className="userInfo">
                                        <h4>{decoded.username}</h4>
                                        <p className="mb-0">#{decoded.empCode}</p>
                                    </div>
                                </Button>
                                <Menu
                                    anchorEl={anchorEl}
                                    id="account-menu"
                                    open={open}
                                    onClose={handleMyAccClose}
                                    onClick={handleMyAccClose}
                                    slotProps={{
                                        paper: {
                                            elevation: 0,
                                            sx: {
                                                overflow: 'visible',
                                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                                mt: 1.5,
                                                '& .MuiAvatar-root': {
                                                    width: 32,
                                                    height: 32,
                                                    ml: -0.5,
                                                    mr: 1,
                                                },
                                                '&::before': {
                                                    content: '""',
                                                    display: 'block',
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 14,
                                                    width: 10,
                                                    height: 10,
                                                    bgcolor: 'background.paper',
                                                    transform: 'translateY(-50%) rotate(45deg)',
                                                    zIndex: 0,
                                                },
                                            },
                                        },
                                    }}
                                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                >
                                    <MenuItem onClick={handleMyAccClose}>
                                        <ListItemIcon>
                                            <Settings fontSize="small" />
                                        </ListItemIcon>
                                        <a style={{textDecoration:"none !important"}} href="/reset"><b>Reset PIN</b></a>
                                    </MenuItem>
                                    <MenuItem onClick={handleMyAccClose}>
                                        <ListItemIcon>
                                            <Logout fontSize="small" onClick={handleLogout} />
                                        </ListItemIcon>
                                        
                                        <Button onClick={handleLogout} className="myAcc d-flex align-items-center">Logout</Button>
                                    </MenuItem>
                                </Menu>
                            </div>
                        </div>

                    </div>
                </div>
            </header>

        </>
    );
}

export default Headers;